import { BrowserRouter, Routes, Route  } from 'react-router-dom';
import './App.css';
import Nav from './Components/Nav';
import Home from './Components/Home';
import About from './Components/About';
import News from './Components/News';
import Property from './Components/Property';
import Services from './Components/Services';
import Contact from './Components/Contact';
import Properties from './Components/Properties';
import Realestatemarketing from "./Components/services/Realestatemarketing";
import Realestatebrokerage from './Components/services/Realestatebrokerage';
import Realestatauctions from './Components/services/Realestateauctions';
import Blog from './Components/Blog';
import Realestateconsulting from './Components/services/Realestateconsulting';
import Contractdocumentation from './Components/services/Contractdocumentation';

import Login from './routes/Login/Login';
import Addproperties from './routes/Addproperty/Addproperties';
import Dashboard from './routes/Dashboard/Dashboard';
import Blogpost from './routes/createblogs/Blogpost';
import Privateroute from "./Components/Privateroute";
import Singlepageproperty from './routes/Addproperty/Singlepageproperty';
import { Layout, RequireAuth } from "./routes/Layout/layout";
import Intellectualpropertyrights from './Components/services/Intellectualpropertyrights';
import Realestatevaluation from './Components/services/Realestatevaluation';
import Saleproperty from './Components/Saleproperty';
import Termspage from './Components/Termspage';
import PropertyList from './routes/Addproperty/Propertylist';

//import Header from './Components/Header';

function App() {
  return (
   <BrowserRouter>
   <Nav/>
 
    <Routes>
      <Route path="/" element={ <Home />} />
      <Route path="/properties" element={ <Properties/>} />
      <Route path="/properties/:id" element={<Property/>}/>
      <Route path="/singlepageproperty/:id" element={<Singlepageproperty/>}/>
      <Route path="/about" element={ <About/>} />
      <Route path="/news"  element={ <News/>} />
      <Route path="/saleproperty"  element={ <Saleproperty/>} />
      <Route path="/termspage"  element={ <Termspage/>} />
      
      <Route path="/login"  element={ <Login/> } />
      <Route path="/services" element={ <Services/>} />
        <Route path="/realestatemarketing" element={<Realestatemarketing/>}/>
        <Route path="/realestatevaluation" element={<Realestatevaluation/>}/>
        <Route path="/realestatebrokerage" element={<Realestatebrokerage/>}/>
        <Route path="/realestateauctions" element={<Realestatauctions/>}/>
        <Route path="/realestateconsulting" element={<Realestateconsulting/>}/>
        <Route path="/contractdocumentation" element={<Contractdocumentation/>}/>
        <Route path="/intellectualpropertyrights" element={<Intellectualpropertyrights/>}/>
        <Route path="/blog"  element={<Blog/>}/>
      <Route path="/contact"  element={<Contact/>}/>

      <Route element={<Privateroute/> }>
      <Route path="add-properties"  element={ <Addproperties/> } />
      <Route path="dashboard"  element={ <Dashboard/> } />
      <Route path="blog-post"  element={ <Blogpost/> } />
      <Route path="/propertylist" element={ <PropertyList/> } />

        </Route>
     
    

      
     



    </Routes>
   </BrowserRouter>
  );
}

export default App;
